import { render, staticRenderFns } from "./UserTypeModal.vue?vue&type=template&id=b6d3b352&"
import script from "./UserTypeModal.vue?vue&type=script&lang=js&"
export * from "./UserTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./UserTypeModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports